export let ProductExperienceOption;

(function (ProductExperienceOption) {
  ProductExperienceOption["yes"] = "yes";
  ProductExperienceOption["no"] = "no";
})(ProductExperienceOption || (ProductExperienceOption = {}));